import { I as c } from "../../constants-DeVuDy8J.js";
import { openBlock as i, createElementBlock as d, normalizeClass as l, createElementVNode as n } from "vue";
import { _ as o } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const s = {
  name: "DtIconQuote",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(c).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return c[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, m = ["aria-label", "data-qa", "aria-hidden"];
function u(e, t, r, _, f, a) {
  return i(), d("svg", {
    "aria-label": r.ariaLabel,
    class: l([a.iconSizeClass, "d-icon d-icon--quote"]),
    "data-qa": a.dataQA,
    "aria-hidden": a.ariaHidden,
    role: "img",
    "data-name": "Quote",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12"
  }, [...t[0] || (t[0] = [
    n("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M5.088 1.41c.285.286.412.677.412 1.09v4c0 1.845-.53 3.012-1.37 3.7-.822.671-1.84.8-2.63.8h-.02c-.107 0-.226 0-.324-.01a.728.728 0 0 1-.447-.199.728.728 0 0 1-.198-.447A3.122 3.122 0 0 1 .5 10.02V8.996c0-.11 0-.23.01-.33a.754.754 0 0 1 .192-.447.726.726 0 0 1 .45-.207C1.254 8 1.376 8 1.486 8H1.5a.51.51 0 0 0 .334-.166A.51.51 0 0 0 2 7.5V7c-.413 0-.802-.126-1.088-.412C.626 6.302.5 5.913.5 5.5V2.486c0-.409.128-.794.414-1.077C1.2 1.126 1.587 1 2 1h1.997c.415-.005.804.122 1.09.41Zm-.709.705c-.058-.058-.167-.118-.372-.115H2c-.212 0-.325.062-.383.12-.057.056-.117.164-.117.366V5.5c0 .212.062.323.12.38.057.058.168.12.38.12h.02c.107 0 .226 0 .324.01a.736.736 0 0 1 .447.199.728.728 0 0 1 .198.447C3 6.754 3 6.873 3 6.98v.52c0 .413-.201.783-.459 1.041C2.283 8.8 1.913 9 1.5 9v1c.71 0 1.442-.121 1.996-.574C4.03 8.988 4.5 8.156 4.5 6.5v-4c0-.212-.062-.326-.121-.385Zm6.708-.705c.286.286.413.677.413 1.09v4c0 1.845-.53 3.012-1.37 3.7-.822.671-1.84.8-2.63.8h-.02c-.107 0-.226 0-.324-.01a.728.728 0 0 1-.447-.199.728.728 0 0 1-.198-.447c-.011-.098-.011-.217-.011-.325V8.5A.5.5 0 0 1 7 8c.333 0 .52-.05.624-.101a.324.324 0 0 0 .167-.176c.042-.097.07-.24.08-.46a5.73 5.73 0 0 0 .007-.267c-.367-.023-.708-.15-.966-.408C6.626 6.302 6.5 5.913 6.5 5.5V2.486c0-.409.128-.794.414-1.077C7.2 1.126 7.587 1 8 1h1.997c.415-.005.804.122 1.09.41Zm-.708.705c-.058-.058-.167-.118-.372-.115H8c-.212 0-.325.062-.383.12-.057.056-.117.164-.117.366V5.5c0 .212.062.323.12.38.057.058.168.12.38.12h.375a.5.5 0 0 1 .5.5l.001.222c.002.198.004.404-.005.59-.013.26-.048.546-.162.81-.122.28-.327.516-.638.67-.17.086-.36.141-.571.174V10c.71 0 1.442-.121 1.996-.574.535-.438 1.004-1.27 1.004-2.926v-4c0-.212-.062-.326-.121-.385Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])], 10, m);
}
const C = /* @__PURE__ */ o(s, [["render", u]]);
export {
  C as default
};
//# sourceMappingURL=quote.js.map
